import { useContext, useEffect, useState } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import ProgramManamgentPop from "./ProgramManagement";
import SellerProfilePop from "./SellerProfile";

// assets
import RightIcon from "bodycodi/cmap/app/svg/icon_right_gray_18.svg";
import Cover from "bodycodi/cmap/app/svg/bodycodi_plus_cover.svg";
import ServiceIntro from "bodycodi/cmap/app/svg/bodycodi_plus_service.svg";

// utils
import { callApi, isEmpty } from "bodycodi/cmap/app/js/common";

const BodycodiPlusMngtTab = ({ seqPlusSeller, seqPartnerCoach, coachName }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const [data, setData] = useState({
    seqPlusSeller: null,
    seqPartnerCoach: null,
    coachName: "",
  });

  useEffect(() => {
    callApi("/cmap5010/viewMyPage", {}, "GET").then((res) => {
      if (isEmpty(res.CoachVO)) {
        res.CoachVO = null;
      }
      setData({
        seqPlusSeller: res?.seqPlusSeller,
        seqPartnerCoach: res?.CoachVO?.seqPartnerCoach,
        coachName: res?.MobileMembersVO?.name,
      });
    });
  }, []);

  const openProgramManagement = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "PROGRAM_MANAGEMENT_POP",
      open: { programManagementPop: true },
    });
  };

  const openSellerProfile = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SELLEER_PROFILE_POP",
      open: { sellerProfilePop: true },
    });
  };

  const handleOpenUrl = () => {
    if (window.ReactNativeWebView) {
      const data = JSON.stringify({
        type: "openExternalLink",
        link: "https://crm-guide.bodycodi.com/39e2953b-9338-48ab-926f-78bd33c61d5e",
      });
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.location.href = "https://crm-guide.bodycodi.com/39e2953b-9338-48ab-926f-78bd33c61d5e";
    }
  };

  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        <div className="bodycodi-plus-cover">
          <img src={Cover} />
        </div>

        <div className="my-page-center-list no-bottom-padding">
          <div className="my-page-center-btn" onClick={openSellerProfile}>
            <span className="title">셀러 프로필 관리</span>
            <img src={RightIcon} />
          </div>
          <div className="my-page-center-btn" onClick={openProgramManagement}>
            <span className="title">프로그램 전시 관리</span>
            <img src={RightIcon} />
          </div>
          <div className="my-page-center-btn disabled" onClick={() => {}}>
            <span className="title">실시간 판매내역(준비중)</span>
            <img src={RightIcon} />
          </div>
          <div className="my-page-center-btn disabled" onClick={() => {}}>
            <span className="title">정산 내역(준비중)</span>
            <img src={RightIcon} />
          </div>
        </div>

        <div className="bodycodi-plus-service-intro" onClick={handleOpenUrl}>
          <div>
            <img src={ServiceIntro} />
            <div>
              <span>바디코디 플러스 알아보기</span>
              <span>새로운 셀러 서비스를 시작해보세요!</span>
            </div>
            <img src={RightIcon} />
          </div>
        </div>
      </div>

      <ProgramManamgentPop seqPlusSeller={data.seqPlusSeller} />
      <SellerProfilePop
        seqPlusSeller={data.seqPlusSeller}
        seqPartnerCoach={data.seqPartnerCoach}
        coachName={data.coachName}
      />
    </>
  );
};

export default BodycodiPlusMngtTab;
